import React from 'react'

const SocialMediaIcons = () => {
	return (
		<div className="left" data-name="social-media-icons">
			<div className="icon-box">
				<a href="https://www.linkedin.com/in/muhammad-saqib2000/" target="_blank" rel="noreferrer">
					<img className="icon" src="./img/l.png" />
				</a>
			</div>
			<div className="icon-box">
				<a href="https://github.com/MUHAMMAD-SAQIB-2000" target="_blank" rel="noreferrer">
					<img className="icon" src="./img/g.png" />
				</a>
			</div>
			<div className="icon-box">
				<a href="https://www.instagram.com/code_with_saqib/" target="_blank" rel="noreferrer">
					<img className="icon" src="./img/i.png" />
				</a>
			</div>
			<div className="icon-box">
				<a href="https://www.hackerrank.com/saqibmakhan" target="_blank" rel="noreferrer">
					<img className="icon" src="./img/h.png" />
				</a>
			</div>
		</div>
	)
}

export default SocialMediaIcons